function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useState, useEffect, useRef } from "react";
import { Form, Space, Button, Input, Select, DatePicker, Alert, Tag, Popover, Statistic, Divider, Drawer } from "antd";
import { Col, Row, Container, Table } from "react-bootstrap";
import Common from "./includes/Common";
import moment from 'moment';
import Moment from 'react-moment';
import { ThreeDots, XLg, PersonFill, ListTask } from "react-bootstrap-icons";
import ReactToPrint, { PrintContextConsumer } from 'react-to-print';
import RistourneDetails from "./RistourneDetails";
import dayjs from "dayjs";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var RangePicker = DatePicker.RangePicker;

var PrescriberCommission = function PrescriberCommission() {
  var _useState = useState(moment().startOf('month').format()),
      _useState2 = _slicedToArray(_useState, 2),
      from = _useState2[0],
      setFrom = _useState2[1];

  var _useState3 = useState(moment().endOf('month').format()),
      _useState4 = _slicedToArray(_useState3, 2),
      to = _useState4[0],
      setTo = _useState4[1];

  var _useState5 = useState(null),
      _useState6 = _slicedToArray(_useState5, 2),
      billsCount = _useState6[0],
      setbillsCount = _useState6[1];

  var _useState7 = useState(null),
      _useState8 = _slicedToArray(_useState7, 2),
      selectedPrescriber = _useState8[0],
      setSelectedPrescriber = _useState8[1];

  var _useState9 = useState(false),
      _useState10 = _slicedToArray(_useState9, 2),
      isFormDataLoading = _useState10[0],
      setIsFormDataLoading = _useState10[1];

  var _useState11 = useState(false),
      _useState12 = _slicedToArray(_useState11, 2),
      isDataLoading = _useState12[0],
      setIsDataLoading = _useState12[1];

  var _useState13 = useState(''),
      _useState14 = _slicedToArray(_useState13, 2),
      errorMessage = _useState14[0],
      setErrorMessage = _useState14[1];

  var _useState15 = useState(false),
      _useState16 = _slicedToArray(_useState15, 2),
      showRistourneDetails = _useState16[0],
      setShowRistourneDetails = _useState16[1];

  var _useState17 = useState([]),
      _useState18 = _slicedToArray(_useState17, 2),
      billsList = _useState18[0],
      setBillsList = _useState18[1];

  var _useState19 = useState([{
    value: 0,
    label: "Tous"
  }]),
      _useState20 = _slicedToArray(_useState19, 2),
      prescribers = _useState20[0],
      setPrescribers = _useState20[1];

  var _useState21 = useState(false),
      _useState22 = _slicedToArray(_useState21, 2),
      open = _useState22[0],
      setOpen = _useState22[1];

  var _Form$useForm = Form.useForm(),
      _Form$useForm2 = _slicedToArray(_Form$useForm, 1),
      form = _Form$useForm2[0];

  var ref = useRef();

  var hide = function hide() {
    setOpen(false);
  };

  var rangePresets = {
    "Aujourdh'ui": [moment().startOf('day'), moment().endOf('day')],
    'Cette semaine': [moment().startOf('week'), moment().endOf('week')],
    'Ce mois': [moment().startOf('month'), moment().endOf('month')]
  };

  var handleOpenChange = function handleOpenChange(newOpen) {
    setOpen(newOpen);
  };

  var handleBusinessProviderChange = function handleBusinessProviderChange(v) {
    if (prescribers.filter(function (p) {
      return p.value == v;
    }).length > 0) setSelectedPrescriber(prescribers.filter(function (p) {
      return p.value == v;
    })[0]);
  };

  var onFinish = function onFinish(values) {
    setIsFormDataLoading(true);
    setFrom(dayjs(values.period[0].$d).format());
    setTo(dayjs(values.period[1].$d).format());
    setSelectedPrescriber(prescribers.filter(function (p) {
      return p.value == values.prescriber_id;
    })[0]);
    axios.get(Common.baseApiUrl + "getprescriberbills/" + dayjs(values.period[0].$d).format() + "/" + dayjs(values.period[1].$d).format() + "/" + values.prescriber_id + "/" + Common.currentUser.id).then(function (response) {
      if (response.data.status == 200) {
        setbillsCount(response.data.bills.length);
        setBillsList(response.data.bills);
        setOpen(false);
      } else {
        setErrorMessage(response.data.message);
      }
    })["catch"](function (error) {
      setErrorMessage('Une erreur est survenue ' + error.toString());
    })["finally"](function () {
      setIsFormDataLoading(false);
    });
  };

  useEffect(function () {
    form.setFieldsValue({
      prescriber_id: 0
    });
    setIsDataLoading(true);
    axios.get(Common.baseApiUrl + "getprescribers/" + Common.currentUser.id).then(function (response) {
      if (response.data.status == 200) {
        setPrescribers([{
          value: 0,
          label: "Tous"
        }]);
        response.data.prescribers.forEach(function (p) {
          setPrescribers(function (prev) {
            return [].concat(_toConsumableArray(prev), [{
              value: p.id,
              label: p.name
            }]);
          });
        });

        if (response.data.prescribers.length > 0) {//form.setFieldsValue({prescriber_id: response.data.providers[0].id});
          //setSelectedPrescriber({value: response.data.providers[0].id, label: response.data.providers[0].name})
        }
      } else {
        setErrorMessage(response.data.message);
      }
    })["catch"](function (error) {
      setErrorMessage('Une erreur est survenue ' + error.toString());
      setIsDataLoading(false);
    });
  }, []);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Container, {
      children: /*#__PURE__*/_jsx(Row, {
        children: /*#__PURE__*/_jsx(Col, {
          lg: 12,
          md: 12,
          children: /*#__PURE__*/_jsxs("div", {
            style: {
              background: "#EAE0E0",
              minHeight: "350px",
              borderRadius: "4px",
              padding: "10px"
            },
            children: [errorMessage.length > 0 && /*#__PURE__*/_jsx(Alert, {
              message: errorMessage,
              type: "error",
              banner: true
            }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsxs(Space, {
              direction: "horizontal",
              children: [/*#__PURE__*/_jsx("h6", {
                style: {
                  color: "#98817F"
                },
                children: /*#__PURE__*/_jsx("b", {
                  children: "R. PRESCRIPTEURS"
                })
              }), /*#__PURE__*/_jsx(Popover, {
                placement: "topLeft",
                open: open,
                trigger: "click",
                onOpenChange: handleOpenChange,
                title: "RECHERCHE",
                content: /*#__PURE__*/_jsxs(Form, {
                  form: form,
                  onFinish: onFinish,
                  layout: "vertical",
                  children: [/*#__PURE__*/_jsx(Form.Item, {
                    name: "prescriber_id",
                    rules: [{
                      required: true,
                      message: "Choisir un apporteur"
                    }],
                    children: /*#__PURE__*/_jsx(Select, {
                      options: prescribers,
                      onChange: handleBusinessProviderChange,
                      placeholder: "Choisir un prescripteur"
                    })
                  }), /*#__PURE__*/_jsx(Form.Item, {
                    name: "period",
                    label: "P\xE9riode",
                    rules: [{
                      required: true,
                      message: "Choisir une date de depart"
                    }],
                    children: /*#__PURE__*/_jsx(RangePicker, {
                      needConfirm: false,
                      format: "DD/MM/YYYY"
                    })
                  }), /*#__PURE__*/_jsxs(Space, {
                    direction: "horizontal",
                    children: [/*#__PURE__*/_jsx(Form.Item, {
                      children: /*#__PURE__*/_jsx(Button, {
                        type: "primary",
                        htmlType: "submit",
                        children: /*#__PURE__*/_jsx("b", {
                          children: "ENVOYER"
                        })
                      })
                    }), /*#__PURE__*/_jsx(Form.Item, {
                      children: /*#__PURE__*/_jsx(Button, {
                        type: "link",
                        onClick: function onClick() {
                          setOpen(false);
                        },
                        icon: /*#__PURE__*/_jsx(XLg, {
                          size: 24
                        }),
                        children: " Fermer"
                      })
                    })]
                  })]
                }),
                children: /*#__PURE__*/_jsx(Button, {
                  children: /*#__PURE__*/_jsx("b", {
                    children: /*#__PURE__*/_jsx(ThreeDots, {
                      size: 20
                    })
                  })
                })
              }), selectedPrescriber && isFormDataLoading == false && billsCount != null && /*#__PURE__*/_jsxs("div", {
                children: [/*#__PURE__*/_jsx(Tag, {
                  color: "#D86A67",
                  children: selectedPrescriber.label
                }), /*#__PURE__*/_jsxs(Tag, {
                  color: "#D86A67",
                  children: ["Du ", /*#__PURE__*/_jsx(Moment, {
                    date: from,
                    format: "DD/MM/YYYY"
                  })]
                }), /*#__PURE__*/_jsxs(Tag, {
                  color: "#D86A67",
                  children: ["Au ", /*#__PURE__*/_jsx(Moment, {
                    date: to,
                    format: "DD/MM/YYYY"
                  })]
                })]
              })]
            }), selectedPrescriber && isFormDataLoading == false && billsCount != null && /*#__PURE__*/_jsxs("div", {
              style: {
                textAlign: "center",
                padding: "10px"
              },
              children: [/*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(PersonFill, {
                size: 45
              }), /*#__PURE__*/_jsx(Statistic, {
                value: billsCount,
                suffix: "Prescription(s)"
              }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), billsCount > 0 && /*#__PURE__*/_jsx(Button, {
                type: "default",
                onClick: function onClick() {
                  setShowRistourneDetails(true);
                },
                children: /*#__PURE__*/_jsxs("b", {
                  children: [/*#__PURE__*/_jsx(ListTask, {
                    size: 18
                  }), " VOIR DETAILS"]
                })
              })]
            })]
          })
        })
      })
    }), billsList.length > 0 && /*#__PURE__*/_jsx(Drawer, {
      title: /*#__PURE__*/_jsxs("b", {
        children: ["RISTOURNES DU ", /*#__PURE__*/_jsx(Moment, {
          date: from,
          format: "DD/MM/YYYY"
        }), " AU ", /*#__PURE__*/_jsx(Moment, {
          date: to,
          format: "DD/MM/YYYY"
        })]
      }),
      destroyOnClose: true,
      width: "95%",
      open: showRistourneDetails,
      onClose: function onClose() {
        setShowRistourneDetails(false);
      },
      extra: [/*#__PURE__*/_jsx(ReactToPrint, {
        content: function content() {
          return ref.current;
        },
        children: /*#__PURE__*/_jsx(PrintContextConsumer, {
          children: function children(_ref) {
            var handlePrint = _ref.handlePrint;
            return /*#__PURE__*/_jsx(Button, {
              type: "primary",
              onClick: handlePrint,
              children: /*#__PURE__*/_jsx("b", {
                children: "IMPRIMER"
              })
            });
          }
        })
      })],
      children: /*#__PURE__*/_jsx(RistourneDetails, {
        bills: billsList,
        ref: ref
      })
    })]
  });
};

export default PrescriberCommission;